import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserStore } from '../../store/user.store';
import { AcuStorageService } from '../../service/acustorage.service';

@Injectable({
    providedIn: 'root'
})
export class CheckLogged implements CanLoad, CanActivate {
    constructor(
        private router: Router,
        private usrStore: UserStore,
        private acuStorage: AcuStorageService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        console.log('CheckLogged => check canActivate', state?.url);
        if (!this.usrStore.userLogged) {
            if (state && state.url && state.url !== '/' && !state.url.startsWith('/login')) {
                this.acuStorage.setRedirectUrl(state.url);
            }
            this.router.navigate(['/login']);
            return false;
        } else {
            return true;
        }
    }

    async canLoad() {
        console.log('CheckLogged => check canLoad');
        if (!this.usrStore.userLogged) {
            this.router.navigate(['/login']);
            return false;
        } else {
            return true;
        }
    }
}
